import { Component } from '@angular/core';

@Component({
  selector: 'gc-form-builder-empty-container',
  templateUrl: './form-builder-empty-container.component.html',
  styleUrls: ['./form-builder-empty-container.component.scss']
})
export class FormBuilderEmptyContainerComponent {
}
